<template>
	<div>
		<ModalSwitch ref="modalSwitch" :listAccount="listAccount"></ModalSwitch>
		<v-app-bar flat app class="" style="z-index: 99;">
			<v-btn id="btn-drawerNav" text small @click.stop="clickDrawer">
				<img width="20" src="/assets/icon/toggle-list.svg" style="opacity: 0.55;filter: brightness(1) invert(1);" v-if="isDrawer === 60">
				<img width="20" src="/assets/icon/toggle-icon.svg" style="opacity: 0.55;filter: brightness(1) invert(1);" v-else>
			</v-btn>
			<v-spacer></v-spacer>
			
			<template v-if="myProfile">
				<!-- <template v-if="Object.keys(myProfile).length > 0 && myProfile.network_type !== 'diamond' && myProfile.network_id !== ''">
					<v-btn title="Upgrade Kemitraan" color="primary" outlined class="mr-5 d-none d-sm-block" @click="gotoUpgrade"><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade Kemitraan</v-btn>
					<v-btn title="Upgrade Kemitraan" small fab depressed color="primary" class="d-sm-none mr-2" @click="gotoUpgrade"><v-icon dense>mdi-shield-account-outline</v-icon></v-btn>
				</template>

				<template v-if="Object.keys(myProfile).length > 0 && myProfile.network_id === ''">
					<v-btn title="Aktivasi Akun" color="warning" outlined class="mr-5 d-none d-sm-block" @click="gotoActivation"><v-icon dense class="mr-1">mdi-account-reactivate-outline</v-icon>Aktivasi Akun</v-btn>
					<v-btn title="Aktivasi Akun" small fab depressed color="warning" class="d-sm-none mr-2" @click="gotoActivation"><v-icon dense>mdi-account-reactivate-outline</v-icon></v-btn>
				</template> -->

				<template v-if="(Object.keys(myProfile).length > 0 && myProfile.member_network_type == 'Ekonomi') && !upgradeData">
					<template v-if="!loadUpgrade">
						<v-btn title="Upgrade Khasanah" color="primary" outlined class="mr-5 d-none d-sm-block" @click="setUpgradeKhasanah"><v-icon dense class="mr-1">mdi-shield-account-outline</v-icon>Upgrade Khasanah</v-btn>
						<v-btn title="Upgrade Khasanah" small fab depressed color="primary" class="d-sm-none mr-2" @click="setUpgradeKhasanah"><v-icon dense>mdi-shield-account-outline</v-icon></v-btn>
					</template>
				</template>
			</template>

			<v-menu open-on-hover offset-y v-if="userData">
				<template v-slot:activator="{ on, attrs }">
					<v-btn large text class="menu-btn pl-1 pr-0" v-bind="attrs" v-on="on">
						<div class="d-none d-md-block cl-grey text-right btn-user-name">
							<div class="text-capitalize cl-white">{{ userData.member_name }}</div>
							<div class="networkcode-info">{{ (userData.member_ref_network_code !== undefined) ? userData.member_ref_network_code : userData.network_code }}</div>
						</div>
						<div class="d-block d-md-none cl-grey text-right btn-user-name">
							<div class="text-capitalize cl-white">{{ userData.member_name | ellipsisText(10) }}</div>
							<div class="networkcode-info">{{ (userData.member_ref_network_code !== undefined) ? userData.member_ref_network_code : userData.network_code }}</div>
						</div>
						<div class="px-2">
							<v-img width="40" height="40" class="user-img rounded-pill" :src="(userData.member_image_url) ? userData.member_image_url : '/assets/image/profile-pict.png'"></v-img>
						</div>
						<v-icon color="grey darken-1">mdi-chevron-down</v-icon>
					</v-btn>
				</template>
				<v-list>
					<a class="text-deco" href="javascript:;" @click="showSwitchMenu" v-if="listAccount.length > 0">
						<v-list-item link style="background:#F7F7F2;">
							<v-icon small color="black" class="pr-3 font-weight-bold">mdi-account-convert</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10 font-weight-bold dark--text">Alih Pengguna</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</a>
					<router-link class="text-deco" :to="{ name: 'profil'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-account</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">Profile</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<router-link class="text-deco" :to="{ name: 'ubah-password'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-key-variant</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">Ubah Password</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<v-list-item link @click.native="onLogout">
						<v-icon small class="pr-3 red--text darken-3">mdi-exit-to-app</v-icon>
						<v-list-item-content>
							<v-list-item-title>
								<span class="font-size-10 font-weight-bold red--text darken-3">Logout</span>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>

		<v-dialog
      v-model="dialogUpgrade"
      persistent
      max-width="500px"
    >
      <v-card style="overflow-y: hidden;">
        <v-card-title>
          <span class="text-h6"><v-icon color="black" class="mr-1">mdi-shield-account-outline</v-icon> Upgrade Khasanah</span>
        </v-card-title>
				<hr class="mt-2 mb-5">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
							<v-text-field
								label="Serial Upgrade"
								color="primary"
								class="input-regis"
								hide-details="auto"
								ref="serial_id"
								outlined
								dense
								prepend-inner-icon="mdi-credit-card-scan-outline"
								v-model="paramsUpgrade.serial_id"
								tabindex="3"
								@keyup="paramsUpgrade.serial_id = paramsUpgrade.serial_id.toUpperCase()"
								:error-messages="(errorValidation !== undefined && errorValidation['serial_id'] !== undefined ) ? [errorValidation['serial_id']] : []"
								:rules="[rules.inputreq('Nomor Serial Upgrade', paramsUpgrade.serial_id)]"></v-text-field>	
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
							<v-text-field
								ref="serialpin"
								label="PIN Serial"
								color="primary"
								class="input-regis"
								prepend-inner-icon="mdi-credit-card-lock-outline"
								v-model="paramsUpgrade.serial_pin"
								hide-details="auto"
								:type="typeInputSerial"
								:append-icon="iconSerial"
								@click:append="showSerial"
								outlined
								dense
								tabindex="4"
								:error-messages="(errorValidation !== undefined && errorValidation['serial_pin'] !== undefined ) ? [errorValidation['serial_pin']] : []"
								:rules="rules.serialpin"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mb-2">
          <v-row justify="center" class="pt-5 ml-0">
						<v-col cols="6" sm="6" md="6" class="pl-0">
							<v-btn large depressed block color="grey" class="white--text rounded-lg" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="clearFormUpgrade">
								<v-icon>mdi-arrow-left</v-icon>
								<span class="pl-2">Batal</span>
							</v-btn>
						</v-col>
						<v-col cols="6" sm="6" md="6" class="pl-0">
							<v-btn large depressed block class="bg-primary white--text rounded-lg" :loading="btnLoadingProses" :disabled="(paramsUpgrade.serial_pin != '' && paramsUpgrade.serial_id != '') ? false : true" tabindex="41" @click="saveUpgradeMitra">
								<v-icon>mdi-content-save-outline</v-icon>
								<span class="pl-2">Upgrade</span>
							</v-btn>
						</v-col>
					</v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
	</div>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex';
// const { mapActions, mapState } = createNamespacedHelpers('auth');
import { mapState, mapActions } from 'vuex'
import ModalSwitch from './ModalSwitch'

export default {
	components: {
		ModalSwitch
	},
	data() {
		return {
			isActiveMember: false,
			dialogUpgrade: false,
			btnLoadingProses: false,
			loadUpgrade: false,
			upgradeData: null,
			paramsUpgrade: {
				serial_id: '',
				serial_pin: ''
			},
			typeInputSerial: 'password',
			iconSerial: 'mdi-eye',
			rules: {
				inputreq(label, v) { 
					return !!v || label + ' tidak boleh kosong'
				},
				input: [
					v => !!v || 'Tidak boleh kosong'
				],
				serialpin: [
					v => !!v || 'PIN Serial tidak boleh kosong'
				],
			},
		}
	},
	props: ['isDrawer'],
	computed: {
		...mapState('auth', ['userData']),
		...mapState('profile', ['myProfile', 'listAccount', 'errorValidation']),
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		async $route(to, from) {
			if (to.name == 'ubah-password') {
				await this.getAccountMitra()
			}
		}
	},
	methods: {
		...mapActions('auth', ['logout']),
		...mapActions('profile', ['getProfileMitra', 'getAccountMitra', 'getUpgradeStatus', 'upgradeKhasanah', 'resetValidation']),

		showSerial() {
			this.typeInputSerial = this.typeInputSerial == 'text' ? 'password' : 'text'
			this.iconSerial = this.iconSerial == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		
		clickDrawer() {
			this.$emit('childToParent')
		},
		onLogout() {
			this.logout().then( () => {
				this.$router.push({ name: 'login' })
			})
		},

		gotoUpgrade() {
			this.$router.push({name: 'upgrade-kemitraan'})
		},

		gotoActivation() {
			this.$router.push({name: 'aktivasi'})
		},

		setUpgradeKhasanah() {
			this.dialogUpgrade = true
		},

		cekUpgradeStatus() {
			this.loadUpgrade = true
			this.getUpgradeStatus().then((res) => {
				this.upgradeData = res.results.data
			}).catch(() => {
				this.upgradeData = null
			})

			setTimeout(() => {
				this.loadUpgrade = false
			}, 1000);
		},

		clearFormUpgrade() {
			this.dialogUpgrade = false
			this.paramsUpgrade = {
				serial_id: '',
				serial_pin: ''
			}
		},

		async saveUpgradeMitra() {
			this.btnLoadingProses = await true
			this.resetValidation()

			let formDataUpgrade = new FormData()
			formDataUpgrade.append('serial_id', this.paramsUpgrade.serial_id)
			formDataUpgrade.append('serial_pin', this.paramsUpgrade.serial_pin)
			
			this.upgradeKhasanah(this.paramsUpgrade).then(() => {
				// this.tempRegister = response.results.data
				this.cekUpgradeStatus()
				location.reload()
				setTimeout(() => {
					this.clearFormUpgrade()
					this.btnLoadingProses = false
				}, 600);
			}).catch(() => {
				this.btnLoadingProses = false
			})
		},

		showSwitchMenu() {
			this.$refs.modalSwitch.modalShow()
		}

	},
	async mounted() {
		await this.getProfileMitra()
		this.getAccountMitra()
		this.cekUpgradeStatus()
	}
};
</script>
